const getCountryAndCodeFromPlace = (dropOffPlace) => {
    let countryCode = 'eg';
    let country = 'egypt';

    if (dropOffPlace.address_components) {
        for (let i = 0; i < dropOffPlace.address_components.length; i++) {
            const component = dropOffPlace.address_components[i];
            if (component.types.includes("country")) {
                countryCode = component.short_name.toLowerCase();
                country = component.long_name.toLowerCase();
                if (countryCode === 'sa') {
                    country = 'saudi-arabia';
                }
                if (countryCode === 'ae') {
                    country = 'emirates';
                }
                break;
            }
        }
    }
    return { countryCode, country };
}

export default getCountryAndCodeFromPlace;